
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    import {useRouter, useRoute} from "vue-router";
    import {useStore} from "@/store";

    interface State {
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        channelType: string;
        reportLevel: number;
        serviceGuarantee: string;
    }
    export default defineComponent({
        name: "ensureService",
        setup() {
            let state: State = reactive({
                isNoDefect: false as any,
                point: 'N' as any,
                channelType: '',
                reportLevel: 0,
                serviceGuarantee: '',
            })
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {isAccident, isFire, isWater, reportConfigInfo} = data
                state.isNoDefect = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y'
                })
                state.serviceGuarantee = reportConfigInfo ? reportConfigInfo.serviceGuarantee : '';
            })
            return {
                state,
                router
            }
        },
        methods: {
            toView(){
                if(this.state.channelType === 'lingshou') {
                    this.router.push({
                        path: '/pdfView'
                    })
                }
                else {
                    this.router.push({
                        path: '/explain',
                        query: {
                            channelType: this.state.channelType,
                            reportLevel: this.state.reportLevel
                        }
                    })
                }
            }
        }
    })
